import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';

@Component({
  selector: 'app-my-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MyButtonComponent
  ],
  templateUrl: './my-dialog.component.html',
  styleUrl: './my-dialog.component.css'
})
export class MyDialogComponent {
  constructor(public dialogRef: MatDialogRef<MyDialogComponent>) {}

  closeModal(): void {
    this.dialogRef.close();
  }
}
